import { observer } from 'mobx-react-lite';
import './Error404.styl';
import { useTranslationsContext } from 'store/translations';
import ErrorIcon from 'assets/img/error_icon.png';

export const Error404Page = observer(() => {
    const { translate } = useTranslationsContext();
    return (
        <div className="error-page">
            <img className="error-page-image" src={ErrorIcon} alt="error icon"></img>
            <div className="error-page-title">{translate('error.page')}</div>
        </div>
    );
});
